<template>
  <div class="toptext_wrap">
    <div class="container">
      <path
        d="M20,230 Q40,205 50,230 T90,230"
        fill="none"
        stroke="blue"
        stroke-width="5"
      />
      <b-jumbotron
        :header="header"
        :lead="leader"
        style="color: white; background-color: rgba(0, 0, 0, 0)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  data() {
    return {
      header: '产品中心',
      leader: '业务、财务一体化高效管理'
    }
  },
  mounted() {

  },
  beforeDestroy() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">

.toptext_wrap {
  background-image: url("../../../assets/sample.png");
  // background-size: 100% 400px;
  height: 100%;
  text-align: left;
  padding-top: 60px;
  padding-bottom: 2px;
  /* max-width: 1200px; */
  margin: 0 auto;
}
.toptext_wrap .btn {
  border-radius: 0;
}

</style>>



// WEBPACK FOOTER //
// src/views/products/components/Banner.vue